module.exports = __webpack_public_path__ + "img/symbol_16.3ecf54e2.png";